import Checkbox from '@/components/atoms/Checkbox';

import type { CageLegendItem } from './types';

import styles from './CageLegend.module.scss';

export interface CageLegendProps {
    items: CageLegendItem[];
    visibleCageIds: Set<number>;
    onToggle: (cageId: number) => void;
}

export default function CageLegend(props: CageLegendProps) {
    const { items, visibleCageIds, onToggle } = props;

    const handleToggle = (cageId: number) => {
        // Don't allow the last visible cage to be hidden (chart would render empty).
        const isOnlyVisible = visibleCageIds.size === 1 && visibleCageIds.has(cageId);
        if (isOnlyVisible) return;
        onToggle(cageId);
    };

    return (
        <div className={styles.container}>
            {items.map((item) => {
                const checked = visibleCageIds.has(item.cageId);
                return (
                    <div
                        key={item.cageId}
                        className={styles.item}
                        onClick={() => handleToggle(item.cageId)}>
                        {/* The row toggles the cage; the box only needs a name for screen
                            readers, as in DatasetLegend. */}
                        <Checkbox
                            checked={checked}
                            onCheckedChange={() => {}}
                            color={item.color}
                            aria-label={item.label}
                        />
                        <span className={styles.label}>{item.label}</span>
                    </div>
                );
            })}
        </div>
    );
}
